import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	filtro: {
		id_tipo: null,
		id_evento: null,
		id_unidade: null,
		id_veiculo: null,
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	},
	lista: [],
	listaTipo: [],
	listaEvento: [],
	listaUnidade: [],
	listaVeiculo: [],
	listaOficina: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'LAUDO_CONTROLE_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'LAUDO_CONTROLE_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'LAUDO_CONTROLE_FILTRO':
            return {
				...state,
				filtro: action.payload.filtro
			};

        case 'LAUDO_CONTROLE_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

         case 'LAUDO_CONTROLE_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

		case 'LAUDO_CONTROLE_EVENTO_SELECT_LISTADO':
			return {
				...state,
				listaEvento: action.payload.data
			};
			
        case 'LAUDO_CONTROLE_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
			};

        case 'LAUDO_CONTROLE_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
			};

		case 'LAUDO_CONTROLE_OFICINA_SELECT_LISTADO':
			return {
				...state,
				listaOficina: action.payload.data
			};

        default:
            return state;
    }
}
